import { type Context, type MutableRefObject, createContext } from 'react';

import { type UseStepsReturn } from '@chakra-ui/react';

type AdminNewInterviewContextType = UseStepsReturn & {
  stepsCount: number;
  jobDescription: MutableRefObject<string | undefined>;
  interviewId: MutableRefObject<string | undefined>;
};

export const AdminNewInterviewContext: Context<AdminNewInterviewContextType> =
  createContext<AdminNewInterviewContextType>(null!);
